<template>
  <div class="px-2 py-2 md:py-5 bg-surface-ground">
    <div class="text-center my-5">
      <h2 class="text-3xl md:text-5xl font-bold">Current Sports Available</h2>
      <p class="text-lg md:text-2xl mt-2">Odds on your favourite sports from 20+ bookmakers.</p>
    </div>

    <div class="grid text-center">
      <div
        v-for="sport in sports"
        :key="sport.title"
        v-animateonscroll="{ enterClass: sport.animationClass }"
        class="col-12 md:col-4 p-4"
      >
        <SportItem
          :title="sport.title"
          :description="sport.description"
          :sportIconName="sport.sportIconName"
        />
      </div>
    </div>

    <Bookmakers />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SportItem from '@/components/splash/SportItem.vue'
import Bookmakers from '@/components/content/Bookmakers.vue'

const alternativeFade = window.innerWidth <= 990

const sports = ref([
  {
    title: 'Soccer',
    description: 'Major European Leagues and more.',
    animationClass: alternativeFade
      ? 'animate-enter fade-in-10 animate-duration-1000'
      : 'animate-enter fade-in-10 slide-in-from-t-20 animate-duration-1000',
    sportIconName: 'soccer',
  },
  {
    title: 'Horse Racing',
    description: 'UK, Ireland and more.',
    animationClass: alternativeFade
      ? 'animate-enter fade-in-10 animate-duration-1000'
      : 'animate-enter fade-in-10 slide-in-from-b-20 animate-duration-1000',
    sportIconName: 'horse-racing',
  },
  {
    title: 'Other Sports',
    description: 'More coming soon!',
    animationClass: alternativeFade
      ? 'animate-enter fade-in-10 animate-duration-1000'
      : 'animate-enter fade-in-10 slide-in-from-t-20 animate-duration-1000',
    sportIconName: 'american-football',
  },
])
</script>
